interface PageHeroProps {
  eyebrow: string;
  title: string;
  titleAccent?: string;
  subtitle: string;
  image: string;
  imageAlt: string;
  cta?: { label: string; href: string; external?: boolean };
}

export default function PageHero({
  eyebrow,
  title,
  titleAccent,
  subtitle,
  image,
  imageAlt,
  cta,
}: PageHeroProps) {
  const handleCta = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="relative min-h-[520px] md:min-h-[600px] flex items-center bg-primary-950 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={imageAlt}
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/95 via-primary-950/85 to-primary-950/60" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 pt-32 pb-16 md:pt-40 md:pb-24">
        <div className="max-w-3xl">
          <p className="text-accent-400 text-sm md:text-base font-semibold tracking-widest uppercase mb-4 md:mb-6">
            {eyebrow}
          </p>
          <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl text-background-50 font-bold leading-[1.1] mb-6">
            {title}
            {titleAccent && (
              <>
                <br />
                <span className="text-accent-400">{titleAccent}</span>
              </>
            )}
          </h1>
          <p className="text-background-200 text-base md:text-lg leading-relaxed max-w-2xl">
            {subtitle}
          </p>

          {cta && (
            <div className="mt-8">
              {cta.external ? (
                <a
                  href={cta.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-400 text-primary-950 text-sm md:text-base font-bold px-8 py-4 rounded-full transition-all whitespace-nowrap"
                >
                  {cta.label}
                  <i className="ri-external-link-line" />
                </a>
              ) : (
                <button
                  onClick={() => handleCta(cta.href)}
                  className="inline-flex items-center justify-center gap-2 bg-accent-500 hover:bg-accent-400 text-primary-950 text-sm md:text-base font-bold px-8 py-4 rounded-full transition-all whitespace-nowrap"
                >
                  {cta.label}
                  <i className="ri-arrow-right-line" />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}